'use strict';

const baseSubmit = require('richemont/experience/components/newsletterComponent');
const $document = $(document);

$document.ready(function () {
    if (window.recaptchaSiteKey) {
        let ready = false;
        $document.on('submit', '.newsletter-form', function (e) {
            if (ready) {
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            const $form = $(this);

            // Check if Google reCaptcha is enabled, and check for the token.
            grecaptcha.ready(function () {
                grecaptcha.execute(window.recaptchaSiteKey, { action: 'submit' }).then((token) => {
                    if (token) {
                        $('<input>').attr('type', 'hidden').attr('name', 'recaptcharesponse').attr('value', token).appendTo($form);
                        ready = true;
                        $form.submit();
                    } else {
                        window.location.href = window.errorRedirectURL;
                    }
                });
            });
        });

        baseSubmit.newsletterSubmit();
    }
});
